module.exports = __webpack_public_path__ + "img/p9.36e4b9eb.png";